<form [formGroup]="fragaForm">
    <div class="modal-body">
        <div class="row">
            <rask-simple-selector
                class="col"
                label="Grupp"
                aid="inputFragaGrupp"
                formControlName="grupp"
                [values]="selectorItems"
                bindLabel="text"
                bindValue="value">
            </rask-simple-selector>
        </div>
        <div class="row">
            <rask-input
                class="col-6"
                aid="inputFragaBeskrivning"
                label="Frågans beskrivning"
                formControlName="beskrivning">
            </rask-input>
            <rask-checkbox
                class="col-6"
                aid="inputFragaAktiv"
                formControlName="aktiv"
                label="aktiv">
            </rask-checkbox>
        </div>
    </div>
    <div class="modal-footer">
        <rask-save-button [disabled]="!canSave()" (click)="onSave()">Spara</rask-save-button>
        <rask-button aid="buttonAvbryt" (click)="onCancel()" color="secondary">Avbryt</rask-button>
    </div>
</form>